export enum JournalType {
  PAYMENTS = "payments",
  BANK_TRANSACTIONS = "bank-transactions",
  BLOCKCHAIN_TRANSACTIONS = "blockchain-transactions",
  BLOCKCHAIN_WITHDRAWALS = "blockchain-withdrawals",
  FX_TICKETS = "fx-tickets",
  POSTINGS = "postings",
}

// Display status mapping
export enum TransactionDisplayStatus {
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
  RETURNED = "RETURNED",
}
